import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

export const SUPABASE_URL =
  import.meta.env.VITE_SUPABASE_URL ?? "https://hdttssbqmohqaxptyasn.supabase.co";

export const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!SUPABASE_PUBLISHABLE_KEY) {
  throw new Error(
    "VITE_SUPABASE_PUBLISHABLE_KEY env var is not set. " +
    "Set it in .env (local) and Vercel project env (production)."
  );
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
  }
});